<template>
  <div id="bm-manage" >
    <div v-if="match" >
      <div class="title" v-if="!passTeams.length && !otherTeams.length" >
        暂无球队管理
      </div>
      <div class="title" v-if="passTeams.length || otherTeams.length" >
        球队管理
      </div>
      <div v-if="match" >
        <van-cell-group>
          <van-cell title="赛事报名" is-link :to="'/setting?matchId='+ matchId" :value="isSignupOn" >
            <!--<template>
              <div>{{ matchSwitch() }}</div>
            </template>-->
          </van-cell>
          <van-cell title="参赛球队" is-link :to="'/participate?matchId='+ matchId" :value="passTeams.length" />
          <van-cell title="报名球队" is-link :to="'/sign-up?matchId='+ matchId" >
            <template>
              <div class="other" >
                {{otherTeams.length}}
                <span class="warning" v-if="isShowWarning" ></span>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="foot" v-if="match" >
        <van-button type="primary" size="large" @click="routerInvite" >邀请球队</van-button>
        <van-button type="default" size="large" @click="routerIntroduction" >导入球队</van-button>
        <van-button type="default" size="large" @click="routerCreate" >创建球队</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, Button, Toast } from 'vant'
import { getBMMatchTeams } from '@/api/team'

Vue.use(Cell).use(CellGroup).use(Button).use(Toast)

export default {
  name: 'Manage',
  data() {
    return {
      match: null,
      matchId: null,
      query: this.$route.query,
      passTeams: [],
      otherTeams: []
    }
  },
  computed: {
    isSignupOn() {
      return this.match.signUpRule.allowTeamSignUp === 1 ? '开启' : '关闭'
    },
    isShowWarning() {
      return this.otherTeams.some((item) => {
        if (item.auditStatus === 0 || item.auditStatus === 1) {
          return true
        }
      })
    }
  },
  created() {
    this.matchId = this.query.matchId
    if (!this.matchId) {
      Toast.loading({
        mask: true,
        message: '参数错误',
        duration: 0
      })
      return
    }
    this.popupLoading.loading()
    this.getBMMatchTeams()
  },
  methods: {
    routerMatchSetting() {
      this.$router.push({
        path: '/setting',
        query: {
          matchId: this.matchId
        }
      })
    },
    routerInvite: function () {
      this.$router.push({ name: 'Invitation', query: {matchId: this.matchId} })
    },
    routerIntroduction: function () {
      this.$router.push({ name: 'Introduction', query: {matchId: this.matchId} })
    },
    routerCreate: function () {
      this.$router.push({ name: 'CreateTeam', query: {matchId: this.matchId} })
    },
    getBMMatchTeams() {
      getBMMatchTeams({ matchId: this.matchId }).then((response) => {
        if (response) {
          this.match = response.data.match
          this.passTeams = response.data.passTeams
          this.otherTeams = response.data.otherTeams
          this.popupLoading.clear()
        }
      })
    }
  }
}
</script>

<style lang="stylus">
#bm-manage
  height: 100%
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  .van-hairline--top-bottom::after
    border-width 0
  .van-hairline--top-bottom
    ::after
      border-width 0px
  .van-cell-group
    .van-cell
      font-weight:300;
      color: rgba(74,74,74,1);
      font-size: 18px
    .van-icon
      color: black
    .van-cell__value
      overflow visible
  .foot
    position absolute
    bottom 0
    left 50%
    transform translate(-50%, 0)
    padding: 0 40px
    width: calc(100% - 80px)
  .foot
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color:rgba(50,163,119,1);
      line-height:25px;
    .van-button--primary
      background-color #32A377
      font-size:16px;
      font-weight:400;
      color:rgba(255,255,255,1);
  .other
    position: relative
  .warning
    display block
    border-radius 50%
    position absolute
    right: -8px
    top: -3px
    width:11px;
    height:11px;
    background:rgba(236,78,78,1);
    border:1px solid rgba(255,255,255,1);
</style>



// WEBPACK FOOTER //
// src/pages/team/manage.vue